import { useState, useEffect } from 'react'
import API from '../services/api.js'

export function useFrameworks() {
  const [frameworks, setFrameworks] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => { fetchFrameworks() }, [])

  async function fetchFrameworks() {
    setLoading(true)
    try {
      // Frameworks are tenant-scoped or global (is_custom=false) — not
      // asset-scoped, matching controls/models.py's Framework FK usage.
      const { data } = await API.get('/frameworks/')
      setFrameworks(data || [])
      setError(null)
    } catch (err) {
      setError(err?.response?.data?.detail || err.message)
    } finally {
      setLoading(false)
    }
  }

  return { frameworks, loading, error, refetch: fetchFrameworks }
}

export function useControls(assetId, frameworkId = null) {
  const [controls, setControls] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (assetId) {
      fetchControls()
    } else {
      setLoading(false)
    }
    // No Django realtime channel yet (unlike the old Supabase
    // postgres_changes subscriptions) — call refetch() after actions
    // that change coverage_status or redteam findings (e.g. after
    // uploading a red-team report, or resolving a finding) instead of
    // relying on a live subscription.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetId, frameworkId])

  async function fetchControls() {
    setLoading(true)
    try {
      const params = { asset_id: assetId }
      if (frameworkId) params.framework_id = frameworkId

      // ControlListCreateView.get already merges each control with its
      // OrgControlStatus row for this asset_id server-side
      // (coverage_status, redteam_alert, redteam_alert_severity) — see
      // controls/views.py's _serialize_with_asset_status. No client-side
      // merge needed anymore, unlike the old Supabase version above.
      const { data } = await API.get('/controls/', { params })
      setControls(data || [])
      setError(null)
    } catch (err) {
      setError(err?.response?.data?.detail || err.message)
    } finally {
      setLoading(false)
    }
  }

  return { controls, loading, error, refetch: fetchControls }
}